// src/models/geral/LeadCaptacao.js
export const intencoesLead = [
  { value: 'teste_gratis', label: 'Teste grátis' },
  { value: 'saber_mais', label: 'Saber mais' },
];

const ramos = {
  alimentacao: 'Alimentação', lancheria: 'Lancheria', restaurante: 'Restaurante', mercado: 'Mercado', bar: 'Bar',
  lojista: 'Lojista', oficina: 'Oficina', prestador_servicos: 'Prestador de serviços', outros: 'Outros',
};
const segmentos = {
  restaurante: 'Restaurante', lancheria: 'Lancheria', hamburgueria: 'Hamburgueria', pizzaria: 'Pizzaria',
  comida_oriental: 'Comida oriental', cafeteria: 'Cafeteria', padaria: 'Padaria',
  confeitaria_doceria: 'Confeitaria/doceria', marmitaria: 'Marmitaria', churrascaria: 'Churrascaria',
  espetaria: 'Espetaria', pastelaria: 'Pastelaria', sorveteria_acai: 'Sorveteria/açaí', buffet: 'Buffet',
  food_truck: 'Food truck', cozinha_delivery: 'Cozinha delivery', bar: 'Bar', pub: 'Pub', choperia: 'Choperia', outros: 'Outros',
};
const atendimentos = { delivery: 'Delivery', retirada_balcao: 'Retirada no balcão', consumo_local: 'Consumo no local' };
const desafios = {
  pedidos_whatsapp: 'Pedidos pelo WhatsApp', papel_caneta: 'Controle em papel e caneta',
  insatisfeito_sistema: 'Insatisfação com o sistema atual', taxas_aplicativos: 'Taxas dos aplicativos',
  emissao_notas_fiscais: 'Emissão de notas fiscais', outros: 'Outros',
};
const tipos = { ainda_nao_abri: 'Ainda não abri', mei: 'MEI', simples_nacional: 'Simples Nacional', outro: 'Outro' };
const dispositivos = { maquina_cartao: 'Máquina de cartão', celular: 'Celular', computador_notebook: 'Computador/notebook' };

const descreverSelecoes = (valores, descricoes) => valores.map(valor => descricoes[valor] || valor).join(', ') || '—';

export const textoLead = valor => valor === null || valor === undefined || valor === '' ? '—' : String(valor);

const formatoData = new Intl.DateTimeFormat('pt-BR', {
  timeZone: 'America/Sao_Paulo', dateStyle: 'short', timeStyle: 'medium',
});

export const formatarDataLead = valor => {
  if (!valor) return '—';
  const data = new Date(valor);
  return Number.isNaN(data.getTime()) ? '—' : formatoData.format(data);
};

export class LeadCaptacao {
  constructor(dados = {}) {
    this.id = dados.id ?? 0;
    this.idEnvio = dados.idEnvio ?? '';
    this.nomeCompleto = dados.nomeCompleto ?? '';
    this.telefone = dados.telefone ?? '';
    this.municipio = dados.municipio ?? '';
    this.uf = dados.uf ?? '';
    this.ramoEmpresa = dados.ramoEmpresa ?? '';
    this.segmentosAlimentacao = Array.isArray(dados.segmentosAlimentacao) ? [...dados.segmentosAlimentacao] : [];
    this.formasAtendimento = Array.isArray(dados.formasAtendimento) ? [...dados.formasAtendimento] : [];
    this.principaisDesafios = Array.isArray(dados.principaisDesafios) ? [...dados.principaisDesafios] : [];
    this.tipoEmpresa = dados.tipoEmpresa ?? '';
    this.dispositivosUso = Array.isArray(dados.dispositivosUso) ? [...dados.dispositivosUso] : [];
    this.intencao = dados.intencao ?? '';
    this.consentimentoContato = dados.consentimentoContato ?? false;
    this.versaoConsentimento = dados.versaoConsentimento ?? '';
    this.dataConsentimento = dados.dataConsentimento ?? null;
    this.dataCadastro = dados.dataCadastro ?? null;
    this.paginaOrigem = dados.paginaOrigem ?? '';
    this.utmSource = dados.utmSource ?? null;
    this.utmMedium = dados.utmMedium ?? null;
    this.utmCampaign = dados.utmCampaign ?? null;
    this.utmContent = dados.utmContent ?? null;
    this.utmTerm = dados.utmTerm ?? null;
    this.gclid = dados.gclid ?? null;
    this.gbraid = dados.gbraid ?? null;
    this.wbraid = dados.wbraid ?? null;
  }

  get ramoDescricao() { return ramos[this.ramoEmpresa] || textoLead(this.ramoEmpresa); }
  get segmentosAlimentacaoDescricao() { return descreverSelecoes(this.segmentosAlimentacao, segmentos); }
  get formasAtendimentoDescricao() { return descreverSelecoes(this.formasAtendimento, atendimentos); }
  get principaisDesafiosDescricao() { return descreverSelecoes(this.principaisDesafios, desafios); }
  get tipoDescricao() { return tipos[this.tipoEmpresa] || textoLead(this.tipoEmpresa); }
  get dispositivosDescricao() {
    return this.dispositivosUso.map(valor => dispositivos[valor] || valor).join(', ') || '—';
  }
  get intencaoDescricao() {
    return intencoesLead.find(opcao => opcao.value === this.intencao)?.label || textoLead(this.intencao);
  }
  get localidade() { return [this.municipio, this.uf].filter(Boolean).join('/') || '—'; }
}
